import { applyMiddleware, createStore, compose, combineReducers } from "redux"
import thunk from "redux-thunk"
import promise from "redux-promise-middleware"
import settings from '../game/config/settings/reducer'
//import {routerReducer} from 'react-router-redux'

//DEMO COMPONENT ABSTRACT REDUX
//import {mixerStore} from 'react-arc'
const middleware = applyMiddleware( promise(),  thunk )
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(middleware)



const reducers = {
    settings
}

const store = Object.keys(reducers).length > 0 ? createStore(combineReducers(reducers), enhancer) : createStore(enhancer)

export default store


// WEBPACK FOOTER //
// ./src/config/store.js